import { useMemo } from 'react';
import useGetUserRecentSearches from 'apollo/userRecentSearch/useGetUserRecentSearches';
import {
    ContentSuggestionParams,
    Suggestions,
    SuggestionsType,
} from '../types';
import getUserSearchFilterToFilterParams from '../helpers/getUserSearchFilterToFilterParams';

const useUserRecentSearchSuggestions = (
    showOnlyFilterSuggestions: boolean,
): Suggestions[] => {
    const userRecentSearches = useGetUserRecentSearches();

    const recentSearchSuggestion: Suggestions[] = useMemo(() => {
        return userRecentSearches
            .map((userRecentSearch) => {
                const { filterSlug, searchFilter } = userRecentSearch;

                const filterParams =
                    getUserSearchFilterToFilterParams(searchFilter);

                return [
                    [filterParams, filterSlug],
                    SuggestionsType.Recent,
                ] as Suggestions;
            })
            .filter(([[filterParams]]) => !!filterParams)
            .filter(
                ([[filterParams]]) =>
                    (filterParams !== ContentSuggestionParams.suggestedlabels &&
                        filterParams !==
                            ContentSuggestionParams.suggestedpacks) ||
                    !showOnlyFilterSuggestions,
            )
            .slice(0, 4);
    }, [userRecentSearches, showOnlyFilterSuggestions]);

    return recentSearchSuggestion;
};

export default useUserRecentSearchSuggestions;
